import React from 'react';
import { CubeIcon, SearchIcon } from '../icons/Icons';

/**
 * ============================================
 * Composant État Vide
 * ============================================
 * Affiché quand aucun produit ne correspond à la recherche/filtre
 */

const EmptyState = ({ searchTerm, selectedCategory, onReset }) => {
    const hasFilters = searchTerm || (selectedCategory && selectedCategory !== 'all');

    return (
        <div className="flex flex-col items-center justify-center py-20 px-4">
            <div className="w-32 h-32 mb-8 bg-gray-100 rounded-3xl flex items-center justify-center">
                {hasFilters ? (
                    <SearchIcon className="w-16 h-16 text-gray-400" />
                ) : (
                    <CubeIcon className="w-16 h-16 text-gray-400" />
                )}
            </div>
            
            <h3 className="text-3xl font-bold text-[#3D3D3D] mb-3 font-serif">
                {hasFilters ? 'Aucun résultat trouvé' : 'Aucun produit disponible'}
            </h3>
            
            <p className="text-gray-600 text-center max-w-lg mb-8 text-lg leading-relaxed">
                {hasFilters 
                    ? `Nous n'avons trouvé aucun produit correspondant à "${searchTerm || selectedCategory}". Essayez d'ajuster vos critères de recherche.`
                    : 'Votre inventaire est actuellement vide. Commencez par ajouter votre premier produit premium.'
                }
            </p>

            {hasFilters && (
                <button
                    onClick={onReset}
                    className="px-8 py-4 bg-[#3D3D3D] hover:bg-[#2D2D2D] text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:scale-105"
                >
                    Réinitialiser les filtres
                </button>
            )}
        </div>
    );
};

export default EmptyState;
